import React, { useState } from "react";
import { Button, Drawer } from "antd";
import "./stylesheets/sideDrawer.css";
import { Link } from "react-router-dom";

const SideDrawer = () => {
  const [open, setOpen] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button
        onClick={() => {
          showDrawer();
        }}
        className="side-drawer-button"
        aria-label="Open Drawer"
      >
        <div className="side-drawer-button-container-div-line1" />
        <div className="side-drawer-button-container-div-line2" />
        <div className="side-drawer-button-container-div-line1" />
      </Button>

      <Drawer
        title={
          <Link to="/">
            <img
              src="/images/drunken-bytes-logo-complete.png"
              alt=""
              className="sideDrawerLogo"
            />
          </Link>
        }
        className="side-drawer"
        placement="right"
        onClose={onClose}
        open={open}
      >
        <div className="side-drawer-main-div">
          <div className="drawer-links">
            <Link to="/create" className="side-drawer-link">
              Create
            </Link>
            <Link to="/pricing" className="side-drawer-link">
              Pricing
            </Link>
            <Link to="/documentation" className="side-drawer-link">
              Documentation
            </Link>
          </div>
        </div>
      </Drawer>
    </>
  );
};
export default SideDrawer;
